import React from 'react'
import { 
    Button
  } from '@material-ui/core';
const WarrantyRegistrationTransferButton = props => {
  return <Button color="primary" variant="contained" onClick={props.addTrip}>Transfer Warranty</Button>
}

export default WarrantyRegistrationTransferButton